module.exports = __webpack_public_path__ + "media/outro.a70d7d97.mp4";